module.exports = __webpack_public_path__ + "media/fr-3.9b647f0c.mp3";